import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Accordion from '../../../components/Accordion';
import SearchContainer from '../../../components/SearchContainer';
import DataTableMui from '../../../components/DataTableMui';

import { buscaDadosv2 } from '../../../services';
import { addMaskCpf } from '../../../utils';

import { useGlobal } from '../../../contexts/Global/context';

import { ContainerDataTable, PageContainer } from '../../../styles/styles';

function Selecionar() {
    const history = useHistory();

    const { dataActiveContract } = useGlobal();

    const emptyMessage = 'Não encontramos esse beneficiário. Você pode fazer uma nova pesquisa.';

    const [loading, setLoading] = useState(false);
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [beneficiarios, setBeneficiarios] = useState([]);

    async function handleSearch(value) {
        setAlreadySearched(false);

        let response = [];
        let treatedResponse = [];

        if (value) {
            setLoading(true);

            response = (await buscaDadosv2(value.trim(), dataActiveContract.numero)) || [];

            treatedResponse = response.map((element, index) => ({
                index,
                nomeCompleto: element.nomeCompleto,
                carteirinha: element.numCarteirinha,
                cpf: addMaskCpf(element.cpf),
                tipo: element.tipo,
                status: element.situacao,
            }));
        }

        setBeneficiarios(response);

        setDataTable(treatedResponse);

        setLoading(false);

        setAlreadySearched(true);
    }

    const columnsHead = [
        {
            key: 'numCarteirinha',
            selector: (row) => row.carteirinha || '-',
            name: 'Nº da carteirinha',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'nomeCompleto',
            selector: (row) => row.nomeCompleto || '-',
            name: 'Nome completo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: 'calc(100% - 580px)', height: '60px' }),
        },
        {
            key: 'cpf',
            selector: (row) => row.cpf || '-',
            name: 'CPF',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '160px' }),
        },
        {
            key: 'tipoBeneficiario',
            selector: (row) => row.tipo,
            name: 'Tipo',
            sortable: true,
            direction: 'center',
            customStyles: () => ({ width: '160px' }),
        },
        {
            key: 'status',
            selector: (row) => row.status,
            name: 'Status',
            sortable: true,
            direction: 'center',
            customStyles: () => ({ width: '120px' }),
        },
    ];

    function handleClickRow(row) {
        const rawData = beneficiarios[row.index];

        history.push({
            pathname: '/dados_beneficiario/beneficiario_dados',
            dataBeneficiario: rawData,
        });
    }

    const rowMutation = {
        click: (row) => {
            handleClickRow(row);
        },
        hasClick: () => true,
    };

    return (
        <>
            <PageContainer>
                <Accordion title="Pesquisar beneficiário" hasCollapse={false}>
                    <SearchContainer
                        field={{
                            id: 'searchField',
                            label: 'Digite o nº da carteirinha, nome ou CPF',
                            required: true,
                        }}
                        disabled={loading}
                        onSearch={handleSearch}
                    />
                </Accordion>
            </PageContainer>

            <ContainerDataTable>
                <DataTableMui
                    clickableRow
                    rowMutation={rowMutation}
                    data={dataTable}
                    pointerOnHover
                    loading={loading}
                    emptyMessage={emptyMessage}
                    columns={columnsHead}
                    alreadySearched={alreadySearched}
                    firstOrderBy="numCarteirinha"
                />
            </ContainerDataTable>
        </>
    );
}

export default Selecionar;
